module.exports = __webpack_public_path__ + "static/media/signup_graphic_2_web.6a349e5a.svg";